<template>
  <div>
    <div v-if="!loading && series.length">
      <vue-apex-charts
          ref="statusDonutChart"
          type="pie"
          height="400"
          :options="chartOptions"
          :series="series"
      />
    </div>
    <div v-else-if="!loading && !series.length" class="text-center my-5">
      <b-alert show variant="warning">
        {{ $t('nodatafound') }}
      </b-alert>
    </div>
    <div v-else class="mt-2" style="max-height: 250px; overflow: hidden;">
      <b-skeleton-img width="100%" height="300px" />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { mapGetters } from 'vuex'

export default {
  name: 'StatusDonutChart',
  components: { VueApexCharts },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('appConfig', ['isDarkMode']),

    series() {
      return this.data.map(item => item.value)
    },
    labels() {
      return this.data.map(item => `${item.name} (${item.value})`)
    },

    // Generate colors in the same order as the data array
    colors() {
      const statusColorMap = {
        REQUESTED: '#f1c40f',   // yellow
        PAID:      '#27ae60',   // green
        CANCELED:  '#e74c3c'    // red
      }
      return this.data.map(item =>
          statusColorMap[item.name] || '#95a5a6' // fallback gray
      )
    },

    chartOptions() {
      return {
        chart: {
          id: 'status-donut-chart',
          foreColor: this.isDarkMode ? '#fafafa' : '#373d3f'
        },
        legend: {
          show: true,
          position: 'bottom',
          fontFamily: 'Montserrat'
        },
        labels: this.labels,
        colors: this.colors
      }
    }
  },
  watch: {
    data() {
      if (this.$refs.statusDonutChart) {
        this.$refs.statusDonutChart.refresh()
      }
    }
  }
}
</script>

<style scoped>
</style>
